import React from 'react';

import { Alert } from '@freelancelabs/components';

import { Refusal } from '../pages/accounts/portalAccess';

interface Props {
    refusal: Refusal;
}

/**
 * A refusal from the API, rendered as information rather than a crash. `role="alert"`
 * because it appears after the click, on a dialog the operator is already reading.
 *
 * It takes a read `Refusal`, not the error: which vocabulary reads a code is the
 * caller's business, and passing the error would make this component pick one.
 */
const RefusalNotice = ({ refusal }: Props) => (
    <div role="alert">
        <Alert type="danger" title={refusal.title}>
            <p className="text-sm">{refusal.guidance}</p>
            {refusal.detail && (
                <p className="mt-2 break-words rounded-md border border-border-norm bg-background-weak p-2 font-mono text-xs">
                    {refusal.detail}
                </p>
            )}
        </Alert>
    </div>
);

export default RefusalNotice;
